var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgServer = function SvgServer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M456,144c13.255,0,24-10.745,24-24V24c0-13.255-10.745-24-24-24H24C10.745,0,0,10.745,0,24v96c0,13.255,10.745,24,24,24 h24v24H24c-13.255,0-24,10.745-24,24v96c0,13.255,10.745,24,24,24h24v24H24c-13.255,0-24,10.745-24,24v96 c0,13.255,10.745,24,24,24h432c13.255,0,24-10.745,24-24v-96c0-13.255-10.745-24-24-24h-24v-24h24c13.255,0,24-10.745,24-24v-96 c0-13.255-10.745-24-24-24h-24v-24H456z M456,352c4.418,0,8,3.582,8,8v96c0,4.418-3.582,8-8,8H24c-4.418,0-8-3.582-8-8v-96 c0-4.418,3.582-8,8-8H456z M64,336v-24h16v24H64z M96,336v-24h288v24H96z M400,336v-24h16v24H400z M456,184c4.418,0,8,3.582,8,8 v96c0,4.418-3.582,8-8,8H24c-4.418,0-8-3.582-8-8v-96c0-4.418,3.582-8,8-8H456z M64,168v-24h16v24H64z M96,168v-24h288v24H96z  M400,168v-24h16v24H400z M24,128c-4.418,0-8-3.582-8-8V24c0-4.418,3.582-8,8-8h432c4.418,0,8,3.582,8,8v96c0,4.418-3.582,8-8,8 H24z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,64H94.528C90.11,51.503,76.397,44.954,63.901,49.373S44.855,67.503,49.273,80s18.131,19.046,30.627,14.627 C86.735,92.211,92.112,86.835,94.528,80H256c4.418,0,8-3.582,8-8S260.418,64,256,64z M72,80c-4.418,0-8-3.582-8-8s3.582-8,8-8 s8,3.582,8,8S76.418,80,72,80z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 32,
    width: 16,
    height: 16
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 32,
    width: 16,
    height: 16
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 32,
    width: 16,
    height: 16
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 32,
    width: 16,
    height: 16
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 32,
    width: 16,
    height: 16
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 64,
    width: 16,
    height: 16
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 64,
    width: 16,
    height: 16
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 64,
    width: 16,
    height: 16
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 64,
    width: 16,
    height: 16
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 64,
    width: 16,
    height: 16
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 96,
    width: 16,
    height: 16
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 96,
    width: 16,
    height: 16
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 96,
    width: 16,
    height: 16
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 96,
    width: 16,
    height: 16
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 96,
    width: 16,
    height: 16
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,232H94.528c-4.418-12.497-18.131-19.046-30.627-14.627S44.855,235.503,49.273,248s18.131,19.046,30.627,14.627 c6.835-2.416,12.211-7.793,14.627-14.627H256c4.418,0,8-3.582,8-8S260.418,232,256,232z M72,248c-4.418,0-8-3.582-8-8s3.582-8,8-8 s8,3.582,8,8S76.418,248,72,248z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 200,
    width: 16,
    height: 16
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 200,
    width: 16,
    height: 16
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 200,
    width: 16,
    height: 16
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 200,
    width: 16,
    height: 16
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 200,
    width: 16,
    height: 16
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 232,
    width: 16,
    height: 16
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 232,
    width: 16,
    height: 16
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 232,
    width: 16,
    height: 16
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 232,
    width: 16,
    height: 16
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 232,
    width: 16,
    height: 16
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 264,
    width: 16,
    height: 16
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 264,
    width: 16,
    height: 16
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 264,
    width: 16,
    height: 16
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 264,
    width: 16,
    height: 16
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 264,
    width: 16,
    height: 16
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,400H94.528c-4.418-12.497-18.131-19.046-30.627-14.627S44.855,403.503,49.273,416s18.131,19.046,30.627,14.627 c6.835-2.416,12.211-7.793,14.627-14.627H256c4.418,0,8-3.582,8-8S260.418,400,256,400z M72,416c-4.418,0-8-3.582-8-8s3.582-8,8-8 s8,3.582,8,8S76.418,416,72,416z"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 368,
    width: 16,
    height: 16
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 368,
    width: 16,
    height: 16
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 368,
    width: 16,
    height: 16
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 368,
    width: 16,
    height: 16
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 368,
    width: 16,
    height: 16
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 400,
    width: 16,
    height: 16
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 400,
    width: 16,
    height: 16
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 400,
    width: 16,
    height: 16
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 400,
    width: 16,
    height: 16
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 400,
    width: 16,
    height: 16
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 432,
    width: 16,
    height: 16
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 432,
    width: 16,
    height: 16
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 432,
    width: 16,
    height: 16
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 432,
    width: 16,
    height: 16
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 432,
    width: 16,
    height: 16
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null)), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null)), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null)), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null)), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null)), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", null)), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", null)), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", null)), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null)), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", null)), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", null)), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", null)), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", null)), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", null)), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/server.572c2f16.svg";
export { ForwardRef as ReactComponent };